import { render, staticRenderFns } from "./Ihbarname891HacizForm.vue?vue&type=template&id=cbfa4fcc&scoped=true"
import script from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"
export * from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa4fcc",
  null
  
)

export default component.exports